import $ from 'jquery';
import template from 'art-template/lib/template-web';
import { getGameInfo } from '../../ajax/api.js';

const head = {
  render() {
    this.renderHead();
  },
  renderHead() {
    getGameInfo({
      success: (data) => {
        const headHtml = template('tpl_head', data);
        $('head').append(headHtml);
      }
    })
  },
};

export default head;
